// Application dependencies

import { PrismaClient as PrismaClientAuthorisation } from "@prisma/prisma-authorisation/client";

// Ensure this is declared at the module level.

declare global {
  // eslint-disable-next-line no-var
  var prismaAuthorisation: PrismaClientAuthorisation | undefined;
}

// Enforce singleton pattern for Prisma.

export const dbAuthorisation =
  globalThis.prismaAuthorisation ??
  new PrismaClientAuthorisation({
    datasources: {
      db: {
        url: process.env.DATABASE_URL_AUTHORISATION,
      },
    },
  });

// Only assign in development to prevent global pollution in production.

if (process.env.NODE_ENV !== "production") {
  Object.defineProperty(globalThis, "prismaAuthorisation", {
    value: dbAuthorisation,
    writable: false,
  });
}
